export default theme => ({
  gridContainer: {
    marginBottom: 25,
    // padding: 10,
    // borderWidth: 1,
    // borderStyle: 'solid',
    // borderColor: 'rgba(0,0,0,0.4)',
    borderRadius: 5,
    // background: "white",
    // boxShadow: "1px 1px 10px #ddd"
  },
  gridItem: {
    padding: 5,
  },

  // used on all inputs (generic styling)
  input: {
    background: 'transparent',
    // borderWidth: 0,
    // borderBottom: '1px solid #aaa',
    // paddingTop: 5,
    // paddingBottom: 5,
    '&:focus': {
      outline: 'none',
    },
    alignSelf: 'stretch',
  },

  textInput: {
    // width: '100%',
    fontSize: 14,
    // color: '#333',
    // paddingBottom: 3,

    border: '1px solid #aaa',
    borderRadius: 4,
    padding: '6px 8px',
    boxSizing: 'border-box',
    minHeight: 31,
    height: 31,
    // margin: -10
  },

  switchInput: {
    // width: 'auto'
  },
  switchInputLabel: {
    fontSize: '0.8em',
    color: 'rgba(0,0,0,0.6)',
  },

  fullWidth: {
    width: '100%',
  },

  inputLabel: {
    fontSize: 12,
    color: '#777',
  },

  fieldLabel: {
    margin: 0,
    marginBottom: 2,
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 1.2,
  },

  disabledText: {
    color: '#888',
  },
  disabledInput: {
    background: '#eee',
    color: 'rgba(0,0,0,0.6)',
  },

  textLabelError: {
    color: 'red',
    fontWeight: 'bold',
  },
  textInputError: {
    borderBottom: '2px solid red',
  },

  textLabelSuccess: {
    color: 'rgb(100,230,100)',
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    // marginTop: 30
  },

  inputContainer: {
    // width: "100%",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    margin: 0,
    // padding: 10,
    width: '100%',
  },

  dropzone: {
    backgroundColor: '#F8F8F8',
    borderStyle: 'dashed',
    borderWidth: 2,
    borderColor: 'rgba(0,0,0,0.1)',
    color: 'rgba(0,0,0,0.4)',
    padding: 20,
    textAlign: 'center',
  },
  dropzoneContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  dropzoneImage: {
    flex: 1,
    maxHeight: 95,
  },
});
